import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./style/App.scss";

import ProtectedRoute from "./components/ProtectedRoute.js";


//Componentes
const Header = lazy(() => import("./components/Header"));
const Footer = lazy(() => import("./components/Footer"));
// paginas
const Posts = lazy(() => import("./pages/Post/PostList.js"));
const PostDetail = lazy(() => import("./pages/Post/PostDetail.js"));
const Introduccion = lazy(() => import("./pages/home/introduccion.js"));
const Reglamento = lazy(() => import("./pages/Admin/reglamento/reglamento.js"));
const Infinity = lazy(() => import("./pages/infinity/infinity.js"));
// Admin
const CreatePostPage = lazy(() => import("./pages/Admin/admin/CreatePost.js"));
const UserDashboard = lazy(() => import("./pages/Admin/Users/userDashboard.js"));
const EditPostPage = lazy(() => import("./pages/Admin/admin/EditPostPage.js"));

function App() {
  return (
    <Router>
      <div className="App">
        <Suspense fallback={<p>cargando...</p>}>
          <Header />
          <Routes>
            <Route index element={<Posts />} />
            <Route path="/introduccion" element={<Introduccion />} />
            <Route  path="/reglamento" element={<Reglamento />} />
            <Route  path="/infinity" element={<Infinity />} />
            <Route path="posts/:id" element={<PostDetail />} />
            <Route
              path="/posts/create"
              element={
                <ProtectedRoute>
                  <CreatePostPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <UserDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/posts/edit/:slug"
              element={
                <ProtectedRoute>
                  <EditPostPage />
                </ProtectedRoute>
              }
            />

          </Routes>
          <Footer />
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
